import { Routes, Route, useLocation } from 'react-router-dom';
import {
  ActiveCampaigns,
  CampaignLeadeboard,
  ForgetPasswordPage,
  GameHistroy,
  Home,
  LeaderBoard,
  Live,
  LiveMatch,
  LoginPage,
  NotFound,
  Notification,
  QuizPage,
  QuizPlay,
  QuizResults,
  Referral,
  SignupPage,
  Transections,
  ViewQuizHistry,
} from './routes';
import AppShell from './layouts/AppShell';
import Profile from './pages/profile';
import ChangePassword from './pages/change-password';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { useNotificationPermission } from './hooks/useNotificationPermission';

export function App() {
  useNotificationPermission();
  const location = useLocation();
  return (
    <Routes location={location} key={location.pathname}>
      <Route element={<AppShell />}>
        <Route path="/" element={<Home />} />
        {/* <Route element={<ProfileLayout />}> */}
        <Route element={<ProtectedRoute />}>
          <Route path="/live" element={<Live />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/referral" element={<Referral />} />
          <Route path="/live-match" element={<LiveMatch />} />
          <Route path="/leader-board/:id" element={<LeaderBoard />} />
          <Route path="/quiz-play/:quizId" element={<QuizPlay />} />
          <Route path="/quiz-results" element={<QuizResults />} />
          <Route path="/game-history" element={<GameHistroy />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/view/:quizId/:type" element={<ViewQuizHistry />} />
          {/* campaign routes */}
          <Route path="/acitve-campaign" element={<ActiveCampaigns />} />
          <Route path="/campaign-leaderboard/:id?" element={<CampaignLeadeboard />} />
          {/* transections page */}
          <Route path="/transections" element={<Transections />} />
        </Route>
      </Route>

      {/* </Route> */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forget-password" element={<ForgetPasswordPage />} />

      {/* Profile routes */}

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
